<div class="header">
    <h1>
        <div [innerHTML]="termsOfServiceTitle" async | pipeSafeHTML></div>
    </h1>
    <div [innerHTML]="termsOfServiceText" async | pipeSafeHTML></div>
    <div class="mt-4 w-100 d-flex justify-content-center">
        <div>
            <button class="mwp-button" (click)="download()">Download Terms Of Service Here</button>
        </div>
    </div>
</div>